import { ArquivoUpload, LoadingComponent } from '@components';
import { RecadastramentoContext } from '@contexts';
import { BancoAgEntidade, WebRecadParticipanteDadosEntidade } from '@entidades';
import { Alert, Button, Col, ComboBox, Form, Input, Row } from '@intech/web-ui';
import { RecadastramentoService } from '@services';
import { ArquivoUploadItem } from '@src/components/ArquivoUpload';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

interface IProps {
  avancar: (PassoEspecifico?: number | null) => Promise<void>;
  voltar: (PassoEspecifico?: number | null) => Promise<void>;
}

export const Passo5: React.FC<IProps> = ({
  avancar,
  voltar
}) => {
  const context = useContext(RecadastramentoContext);
  const isMountedRef = useRef(true);
  const form = useRef<Form>(null);

  const [ListaArquivo, setListaArquivo] = useState<Array<ArquivoUploadItem>>(new Array<ArquivoUploadItem>());
  const [Banco, setBanco] = useState<string>("");
  const [NomeBanco, setNomeBanco] = useState<string>("");
  const [Agencia, setAgencia] = useState<string>("");
  const [Conta, setConta] = useState<string>("");
  const [OpcoesBanco, setOpcoesBanco] = useState<BancoAgEntidade[]>([]);
  // const [DadosOriginais, setDadosOriginais] = useState<WebRecadParticipanteDadosEntidade>(null);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");
  const [ErroForm, setErroForm] = useState<string>("");

  useEffect(() => () => { isMountedRef.current = false }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        if (!isMountedRef.current)
          return;

        const dados = await context.buscarDadosParticipante();
        const dadosOriginais = await context.buscarDadosOriginais();

        const bancos = await RecadastramentoService.BuscarListaBanco();

        const ListaArquivo = await context.buscarListaArquivo();

        const codigoBanco = (dados.NUM_BANCO || dadosOriginais.NUM_BANCO || "");
        const banco = bancos.filter(x => x.COD_BANCO === codigoBanco)[0];

        setListaArquivo(ListaArquivo);
        setBanco(codigoBanco);
        setNomeBanco(banco ? banco.DESC_BCO_AG : "-");
        setAgencia(dados.NUM_AGENCIA || dadosOriginais.NUM_AGENCIA || "");
        setConta(dados.NUM_CONTA || dadosOriginais.NUM_CONTA || "");
        setOpcoesBanco(bancos);
        // setDadosOriginais(dadosOriginais);
      } catch (e) {
        const error: any = e;
        const messsage = error.response ? error.response.data : error;
        setErro(messsage);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function salvarDados() {
    try {
      if (form?.current?.validate()) {

        const dados = await context.buscarDadosParticipante();
        dados.NUM_BANCO = Banco;
        dados.NUM_AGENCIA = Agencia;
        dados.NUM_CONTA = Conta;

        context.salvarDadosParticipante(dados);
        context.salvarListaArquivo(ListaArquivo);
        return true;
      }
      return false;
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
      return false;
    }
  }

  async function handleVoltar() {
    form?.current?.clear();
    setErroForm("");
    try {
      if (await salvarDados()) {
        voltar();
      }
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  }

  async function handleAvancar() {
    form?.current.clear();
    setErroForm("");
    try {
      if (await salvarDados()) {
        avancar();
      }
    }
    catch (e) {
      const error: any = e;
      const messsage = error.response ? error.response.data : error;
      setErroForm(messsage);
    }
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={'danger'}>{Erro}</Alert>}

      {!Loading && !Erro && (
        <>
          <Form ref={form}>
            {/* <ComboBox
              data={OpcoesBanco}
              title={"Número do Banco"}
              value={Banco}
              onChange={setBanco}
              memberName={"DESC_BCO_AG"}
              memberValue={"COD_BANCO"}
              disabled
            /> */}

            <Input
              value={NomeBanco}
              title={"Banco"}
              readonly
            />

            <Input
              value={Agencia}
              title={"Agência (com o Dígito)"}
              max={5}
              readonly
            />

            <Input
              value={Conta}
              title={"Conta Corrente (com o DV)"}
              max={15}
              readonly
            />

            <Alert formAlert type={"danger"} />
            <Alert type={"danger"} >{ErroForm}</Alert>

            <ArquivoUpload
              ListaArquivo={ListaArquivo}
              setListaArquivo={setListaArquivo}
              texto={"Em caso de alteração de dados bancários será necessário enviar comprovante, como por exemplo imagem de: topo do extrato bancário, cartão bancário ou tela inicial do aplicativo do banco. Lembramos que a Faelce atua para pagamento de benefícios apenas com o Banco do Brasil e Banco Santander."}
              passo={"Passo5"}
              controller={"Recadastramento"}
            />

            <Row>
              <Col>
                <Button
                  type={"secondary"}
                  title={"Voltar"}
                  icon={<FaAngleDoubleLeft />}
                  onClick={handleVoltar}
                  loadingText={"Voltando..."}
                  usesLoading
                  block
                  iconRight
                />
              </Col>

              <Col>
                <Button
                  type={"primary"}
                  title={"Continuar"}
                  icon={<FaAngleDoubleRight />}
                  onClick={handleAvancar}
                  loadingText={"Continuando..."}
                  usesLoading
                  block
                />
              </Col>
            </Row>
          </Form>
        </>)}
    </>
  );
}
